//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
//@ts-nocheck
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Stack,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import Select from "../../../../components/form-elements/Select";
import SubjectPicker from "../SubjectPicker";
import { useSubjectSelector, useSubjectSelectorContext } from "./hook";

const SubjectSelector = ({
  value,
  onChange,
  placeholders: placeholderProp,
  errorMessage = {},
  isInvalid = {},
  spacing = "24px",
  dataType,
  path,
}: any) => {
  const { onChange: selectOnChange }: any = useSubjectSelectorContext();

  const { placeholders, values, handleChange, options, classOptions } =
    useSubjectSelector(value, placeholderProp, dataType);
  useEffect(() => {
    onChange && onChange(values);
    selectOnChange(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values]);

  return (
    <Stack spacing={spacing}>
      <FormControl isInvalid={Boolean(isInvalid.class)}>
        <FormLabel>{placeholders.class.label}</FormLabel>
        <Select
          value={values.class}
          onChange={(value) => handleChange("class", value)}
          options={classOptions}
          isInvalid={isInvalid.class}
          isSearchable={true}
          {...placeholders.class}
        />
        <FormErrorMessage>{errorMessage.class}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={Boolean(isInvalid.purpose)}>
        <FormLabel>{placeholders.purpose.label}</FormLabel>
        <Select
          value={values.purpose}
          onChange={(value) => {
            handleChange("purpose", value);
          }}
          options={options.purpose}
          isInvalid={isInvalid.purpose}
          noOptionsMessage={() => "Select a class first"}
          size={values.purpose ? "xl" : "lg"}
          isSearchable={true}
          {...placeholders.purpose}
        />
        <FormErrorMessage>{errorMessage.purpose}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={Boolean(isInvalid.subjects)}>
        <FormLabel>{placeholders.subjects.label}</FormLabel>
        <SubjectPicker
          onChange={(values) => handleChange("subjects", values)}
          options={options.subjects}
          value={values.subjects}
          values={values}
          isInvalid={isInvalid.subjects}
          {...placeholders.subjects}
          path={path}
        />
        <FormErrorMessage>{errorMessage.subjects}</FormErrorMessage>
      </FormControl>
    </Stack>
  );
};

export const EnhancedSubjectSelector = ({ value, ...props }) => {
  let { data }: any = useSubjectSelectorContext();
  let text = data.subjects.join("::");
  let _value = value.subjects.join("::");
  let key = text === _value ? "first" : "second";
  let newValue =
    key === "first" ? value : data.subjects.length > 0 ? data : value;
  // return <SubjectSelector key={key} value={newValue} {...props} />;
  return <SubjectSelector value={newValue} {...props} />;
};

export default SubjectSelector;
